import { LogLevel } from "angular-auth-oidc-client";

export const environment = {
  production: true,
  locale: "it",
  baseHref: "/it/", //di fatto serve solo a silent.html per il refresh
  redirectUri: "/it/area-utente",
  authUrl: 'https://identity.dolomitiemergency.it',
  logoutUri: 'https://my.dolomitiemergency.it/',
  adminUrl: 'https://admin.dolomitiemergency.it',
  logLevel: LogLevel.Error,
  showRouteEvent: false,
  publicStripeKey: "pk_live_51JXLLTJQrVQ4YPyblds9SsEMnb1eMUttykFLknrOmm5Wf38XoUSOWHYLjH3p308MXeKjBBXW282pviT5VJskVeW200JEEiAra6"
};
